import React from 'react';
import '../Routes.css';

function Home() {
  return (
    <div className="page__container">
      <h1 className="page__heading">Home</h1>
    </div>
  );
}

export default Home;
